export default {
  // ========== Botones y acciones ==========
  openInNewTab: 'Abrir en otra pestaña',

  // ========== Idioma de la Asignatura ==========
  matterLanguageLabel: 'Idioma de {entity}',

  // ========== Títulos de secciones ==========
  programs: 'Programas',
  subjectDescription: 'Descripción Asignatura',
  evaluation: 'Evaluación',
  learningExperiences: 'Experiencias de Aprendizaje',
  piaCampus: 'PIA Sede',
  paStudent: 'PA Estudiante',
  pdaTeacher: 'PDA Docente',
  bibliographicResources: 'Recursos Bibliográficos',

  // ========== Mensajes informativos ==========
  tributesToCompetences: 'a las que tributa la',
  doesNotTribute: 'Esta {entity} no tributa a ninguna',

  // ========== Tooltips informativos ==========
  defaultDescriptorInfo: 'Si se selecciona el predeterminado, se habilitará el enunciado del descriptor en otros Programas.',
  notFoundResourcesWarning: 'No se encontraron Recursos Bibliográficos con el Código de la',

  // ========== Confirmaciones de eliminación ==========
  deleteTitleConfirm: '¿Está seguro de que desea eliminar el título descriptivo?',
  deleteTitleWarning: 'Esta acción no se podrá revertir y se eliminarán los objetos referenciados en la parte inferior.',
  deleteContentConfirm: '¿Está seguro de que desea eliminar el contenido del título descriptivo?',
  affectOthersWarning: 'Esta acción no se podrá revertir y podría afectar en otras',
  moveSectionConfirm: '¿Está seguro de que desea mover el título descriptivo a esta sección?',
  moveSectionWarning: 'La sección es del título descriptivo: se moverá en el programa de todas las {entity} que lo usan.',
  moveSectionLocked: 'Este título descriptivo es del sistema y no se puede cambiar de sección.',

  // ========== Confirmaciones de cierre ==========
  closeSubjectConfirm: '¿Está seguro de que desea cerrar la',
  closeSubjectWarning: 'Teniendo en cuenta que no ha asignado ninguna',

  // ========== Mensajes de éxito ==========
  descriptorCreated: 'Descriptor creado.',
  descriptorUpdated: 'Descriptor actualizado.',
  subjectUpdated: 'actualizada.',
  competencesUpdated: 'actualizadas.',
  descriptionUpdated: 'Descripción de {entity} actualizada.',

  // ========== Etiquetas de formulario ==========
  title: 'Título',
  content: 'Contenido',
  assign: 'Asigne una',
  toThe: 'a la',
  inTheSection: 'en el apartado',
  without: 'sin',
  without2: 'Sin',

  // ========== Time Allocation Component ==========
  enterDataBy: 'Ingresar datos por:',
  week: 'Semana',
  total: 'Total',
  pedagogicalHours: 'Horas Pedagógicas',
  includeIn: 'Incluir en {entity}',
  attendancePercentageRequired: 'Porcentaje de asistencia requerido',
  studentsPerHour: 'N° de estudiantes',
  fieldNotEmptyAndNotLessThanZero: 'Este campo no debe estar vacío y no debe ser menor a 0.',
  minutesPerPedagogicalHourFormula: '{entity1}({value1}) * Cantidad de Minutos por Hora Pedagógica({value2}/60)= {result}',

  // ========== Info Evaluations Component ==========
  allEntitiesComplete: 'Todas las {entity} están completas.',
  incompleteEntities: '{entity} Incompletas',
  requireCompleteTheseEntities: 'Requiere completar estas {entity}.',
  entitiesToClose: '{entity} por Cerrar',
  mustCloseTheseEntities: 'Debe cerrar estas {entity}.',
  closeEntities: 'Cerrar {entity}',
  openEntities: 'Abrir {entity}',
  clickToUpdateData: 'Haz clic para actualizar los datos.',
  updateData: 'Actualizar Datos',
  goDirectlyTo: 'Ir directamente a {entity}',
  ilNotMentioned: 'IL no mencionados',
  mustIncludeAllEntitiesInActivities: 'Debe incluir todos los {entity1} en las Actividades/{entity2}.',
  entityDoesNotHaveAnyEvaluationCreated: 'La {entity} no cuenta con ninguna evaluación creada.',
  evaluationDoesNotHaveEntity: 'La evaluación no cuenta con {entity}.',

  // ========== Matter Presentation Component ==========
  planLevel: 'nivel del plan',
  prerequisite: 'prerrequisito',
  prerequisites: 'prerrequisitos',
  doesNotHave: 'No tiene',
  requirements: 'Requisitos',
  weeks: 'semanas',
  numberOfTeachers: 'N° docentes',
  isExemptable: 'eximible',
  autonomousWorkHours: 'horas de trabajo autónomo',
  publicationDate: 'fecha de publicación',
  pmdStatus: 'estado del pmd',
  notStarted: 'No iniciado',
  inProgress: 'En proceso',
  completed: 'Finalizado',
  activityType: 'tipo de actividad',
  attendanceRequirement: 'exigencia de asistencia',
  weekly: 'semanal',
  includeInCountable: 'Se incluye en el {entity} contables',
  notIncludeInCountable: 'No se incluye en el {entity} contables',
  publicationDateUpdated: 'Fecha de Publicación Actualizada',

  // ========== Evaluation Criteria Macro Component ==========
  entityDoesNotHaveEntity: 'Esta {entity1} no cuenta con {entity2}',
  weighing: 'Ponderación',
  contents: 'Contenidos',

  // ========== Evaluation Criteria Macro Form ==========
  addCriteria: 'Agregar criterio',
  weighingLimitReached: 'Se ha alcanzado el 100% de ponderación.',
  noEntity: 'No hay {entity}',
  entityDeleted: '{entity} eliminado.',
  weighingDescription: 'Ponderación con respecto al Resultado de Aprendizaje.',
  testWeighingOf: 'Ponderación del {entity}',
  available: 'Disponible',
  requiredFieldMaxValue: 'Este campo es obligatorio y no debe exceder {max}.',
  requiredFieldBetweenValues: 'Este campo es obligatorio y debe estar entre {min} y {max}.',

  // ========== EC Macro Content Component ==========
  addContentsSeparately: 'Agregue los contenidos por separado',
  cannotSaveIfEmpty: 'No se puede guardar si está vacío.',

  // ========== Methodological Strategies Row Component ==========
  multiSelectInfo: 'Para seleccionar múltiples elementos, mantenga presionada la tecla Ctrl y a continuación, seleccione los elementos que desee.',
  coloredMinimumEntitiesStart: 'Se muestran',
  coloredMinimumEntitiesColored: 'coloreadas',
  coloredMinimumEntitiesEnd: 'las {entity1} definidas como mínimas para la {entity2}',
  minimumEntitiesOf: 'Estrategias mínimas de la {entity}',

  // ========== Matter Capacities Component ==========
  noAssociatedEntityToShow: 'No hay ninguna {entity} asociada para mostrar.',

  // ========== Competence Units Component ==========
  totalHours: 'Total de horas',
  hours: 'Horas',
  numberAbbreviation: 'N°',
  cannotAddEntityClosedEvaluations: 'No se pueden agregar {entity} dado que existen evaluaciones ya cerradas. Si aún así desea agregar {entity} presione el botón y abra las evaluaciones que se indicarán en la ventana.',
  closedEvaluations: 'Evaluaciones cerradas',

  // ========== UnitSection Component ==========
  addContentsSeparately2: 'Agregue los {entity} por separado',

  // ========== Info Test Table Component ==========
  criteria: 'Criterio',
  complies: 'Cumple',
  problems: 'Problema(s)',
  reviewWeighingsOf1: 'Revisar las ponderaciones de los {entity}',
  reviewWeighingsOf2: 'Revisar las ponderaciones de las {entity}',
  existing: 'existente',
  mustCreateA: 'Se debe crear una {entity}',
  hasFieldSelected: 'Posee el campo {entity} seleccionado',
  mustSelectInForm: 'Se debe seleccionar {article} {entity} en el formulario',
  noInconsistencies: 'No existen inconsistencias',
  exists: 'Existe {entity}',
  weighingOfEntitySums100: 'La ponderación de {gender} {entity} suma 100%',
  allEntitiesContributeTo: 'Todas {gender} {entity1} contribuyen a {gender2} {entity2}',
  sumOfWeighingsDoesNotMatch: 'La suma de las ponderaciones de {gender} {entity1} no concuerda con {gender2} {entity2}',

  // ========== ECM Info Table Component ==========
  mentions: 'Menciones',
  notMentionedInAnyActivityEvaluation: 'No está siendo mencionado en ninguna Actividad/Evaluación',
  activities: 'Actividades',
  activity: 'Actividad',

  // ========== Linking Competence To Ra Component ==========
  linkEntityCreatedToEntity: 'Vincular {entity1} creado a la {entity2}',
  entityLinkedToEntity: '{entity1} vinculado a la {entity2}',
  linked: 'vinculado',
  unlinked: 'desvinculado',

  // ========== Evaluation Criteria Component ==========
  equivalentWeighing: 'Ponderación Equivalente',
  cannotChangeEquivalentWeighing: 'No puede cambiar la Ponderación Equivalente dado que existen evaluaciones ya cerradas. Si aún así desea cambiar la Ponderación presione el botón y abra las Evaluaciones que se indicarán en la ventana',
  weighingLimitReached100: 'Se ha alcanzado el 100% de ponderación',
  cannotAddEntitiesClosedEvals: 'No se pueden agregar {entity} dado que existen evaluaciones ya cerradas. Si aún así desea agregar {entity} presione el botón y abra las Evaluaciones que se indicarán en la ventana',
  cannotDeleteEntitiesClosedEvals: 'No se pueden eliminar {entity} dado que existen evaluaciones ya cerradas. Si aún así desea eliminar {entity} presione el botón y abra las Evaluaciones que se indicarán en la ventana',
  performanceIndicatorOfGenericCompetencies: 'Indicador de Desempeño de las CG',
  deleted: 'Eliminado',

  // ========== Matter Program Evaluation Component ==========
  workTypesOf: 'Tipos de trabajo de',
  summative: 'Sumativas',
  activitiesAndEvaluations: 'Actividades y Evaluaciones',
  createActivityOrEvaluation: 'Crear Actividad o Evaluación',
  type: 'Tipo',
  directTeachingHours: 'Horas Docencia Directa (Horas Pedagógicas)',
  autonomousWorkHours2: 'Horas de Trabajo Autónomo (Horas Cronológicas)',
  chronologicalHours: 'Horas Cronológicas',
  totalOfSubject: 'Total {percent}% de la Asignatura',
  noActivitiesOrEvaluationsToShow: 'No hay actividades o evaluaciones para mostrar',
  unsavedDataWillBeLost: '¿Estás seguro de que quieres cerrar? Los datos no guardados se perderán',
  confirmationRequired: 'Confirmación Necesaria',
  yesClose: 'Sí, cerrar',

  // ========== Copiar Evaluaciones ==========
  copyEvaluations: 'Copiar Evaluaciones',
  copyEvaluationsModalTitle: 'Copiar Evaluaciones',
  copyEvaluationsFrom: 'Copiar desde {entity}',
  copyEvaluationsTo: 'Copiar hacia {entity}',
  copyEvaluationsToEpm: 'Copiar a la {entity} de otro {entity2}',
  copyEvaluationsFromEpm: 'Copiar desde la {entity} de otro {entity2}',
  copyEpmToEpmDesc: 'Las evaluaciones de esta {entity} se exportarán hacia la {entity} del {entityProfile} de destino que selecciones. Las evaluaciones actuales del destino serán eliminadas y reemplazadas por las de esta {entity}. <strong>Requisito:</strong> ambas {entity} deben tener la opción "Vincular Asignatura Base" en <strong>No</strong>.',
  copyEpmFromEpmDesc: 'Las evaluaciones de la {entity} de origen seleccionada se importarán hacia esta {entity}. Las evaluaciones actuales de esta {entity} serán eliminadas y reemplazadas. <strong>Requisito:</strong> ambas {entity} deben tener la opción "Vincular Asignatura Base" en <strong>No</strong>.',
  copyEpmToMatterDesc: 'Las evaluaciones de esta {entity} se exportarán hacia la {entityMatter}. Las evaluaciones actuales de la {entityMatter} serán eliminadas y reemplazadas. Este cambio podría afectar a otras {entityEpm} que estén vinculadas a la {entityMatter}.',
  copyMatterToEpmDesc: 'Las evaluaciones de la {entityMatter} se importarán hacia esta {entity}. Las evaluaciones actuales de esta {entity} serán eliminadas y reemplazadas por las de la {entityMatter}.',
  exportMatterToEpmDesc: 'Las evaluaciones de esta {entityMatter} se exportarán hacia la {entity} del {entityProfile} seleccionado. Las evaluaciones actuales de la {entity} serán eliminadas y reemplazadas. <strong>Requisito:</strong> la {entity} debe tener la opción "Vincular Asignatura Base" en <strong>No</strong>.',
  importEpmToMatterDesc: 'Las evaluaciones de la {entity} del {entityProfile} seleccionado se importarán hacia esta {entityMatter}. Las evaluaciones actuales de esta {entityMatter} serán eliminadas y reemplazadas. Este cambio podría afectar a otras {entity} vinculadas a esta {entityMatter}.',
  selectTargetEpm: 'Seleccione la {entity} de destino',
  copyOptionEpmToEpm: 'Desde otra {entity} del mismo tipo',
  copyOptionEpmToMatter: 'Hacia la {entity}',
  copyOptionMatterToEpm: 'Desde la {entity}',
  selectSourceEpm: 'Seleccione la {entity} de origen',
  swapDirection: 'Invertir dirección',
  copyWithOtherEpm: 'Con otro {entity2}',
  copyWithMatter: 'Con {entity}',
  copyEpmEpmModalTitle: 'Importar/Exportar a otro {entity}',
  copyEpmMatterModalTitle: 'Importar/Exportar a {entity}',
  copyEvaluationsConfirm: 'Esta acción reemplazará todas las evaluaciones actuales del destino y no podrá revertirse. ¿Desea continuar?',
  copyEvaluationsConfirmAddOnly: 'Se agregarán {count} evaluación(es) al destino. Esta acción no podrá revertirse. ¿Desea continuar?',
  copyEvaluationsConfirmAddAndDelete: 'Se agregarán {countAdd} evaluación(es) al destino y se eliminarán {countDelete} evaluación(es) del destino. Esta acción no podrá revertirse. ¿Desea continuar?',
  copyEvaluationsSuccess: 'Evaluaciones copiadas correctamente.',
  copyEvaluationsError: 'Error al copiar las evaluaciones.',
  noEpmAvailableTitle: 'No hay un destino disponible para esta operación',
  noEpmAvailableToCopy: 'Esta {entity} no se encuentra en ningún otro {entityProfile} con evaluaciones propias, por lo que no existe un destino hacia dónde copiarlas. Por ese motivo no se muestra el selector de {entityProfile} y la operación no puede continuar.',
  noEpmAvailableHint: 'Para habilitar esta opción, la {entity} debe existir también en otro {entityProfile} y ese registro debe tener la opción "Vincular Asignatura Base" en No (si está en Sí, esa {entity} usa las evaluaciones de la {entityMatter} y no puede recibir una copia).',
  evaluationsToBecopied: 'Evaluaciones a Exportar (Origen)',
  evaluationsToBeImported: 'Evaluaciones a Importar (Origen)',
  evaluationsToBeReplaced: 'Evaluaciones a Actualizar (Destino)',
  noEvaluationsInSource: 'No hay evaluaciones en el origen.',
  noEvaluationsInTarget: 'No hay evaluaciones en el destino.',
  loadingPreview: 'Cargando vista previa...',
  summaryToAdd: 'Evaluación(es) a agregar',
  summaryToDelete: 'Evaluación(es) a eliminar',
  previewColumnHeader: 'Vista Previa (Resultado)',
  previewColumnEmpty: 'Selecciona evaluaciones para ver el resultado.',
  previewTotal: 'Total ponderación',
  previewTotalExceeded: 'La suma de ponderaciones supera el 100%.',
  previewGroupTransversal: 'Examen Transversal',
  previewNew: 'Nueva',
  previewExisting: 'Permanece',
  belongsToProfile: 'Perfil de Egreso: {profile}',
  sourceLabel: 'Origen',
  targetLabel: 'Destino',
  copyFromMatter: 'Copiar desde {entity}',

  // ========== Estado de contenido de la Evaluación ==========
  hasContent: 'Completo',
  evaluationHasContent:
    'Contenido de {entity1} completo: las preguntas de cada {entity2} suman su puntaje total y las ponderaciones de cada {entity3} suman 100%.',
  evaluationHasNoContent:
    'Contenido de {entity1} incompleto: falta contenido, o los puntajes de las preguntas de {entity2} / las ponderaciones de {entity3} no cuadran.',
  ecMicroInUse: 'En uso en el contenido de la evaluación.',
  ecMicroNotInUse: 'Asignado, pero sin uso en el contenido de la evaluación.',

  // ========== IL Indicators Usage Component ==========
  writtenInstruments: 'Instrumentos Escritos',
  observationInstruments: 'Instrumentos de Observación',
  notMentionedInAnyEvaluation: 'No está siendo mencionado en ninguna Evaluación',
  summaryOfEntitiesEvaluatedIn: 'Resumen de {entity1} evaluados en la {entity2}',
  totalOf: 'Total de',
  notMentioned: 'No mencionados',
  totalQuestions: 'Total de Preguntas',
  totalQuestionsNotAssociatedWith: 'Total de Preguntas no asociadas a {entity}',
  totalOfEntitiesInObservationInstruments: 'Total de {entity} en Instrumentos de Observación',
  entitiesNotAssociatedWith: '{entity1} no asociadas a {entity2}',

  // ========== Study Unit Form ==========
  details: 'Detalles',
  suggestedHours: 'Horas Sugeridas',
  lockEntity: 'Bloquear {entity}',
  unlockEntity: 'Desbloquear {entity}',
  currentlyUnlocked: 'Actualmente el {entity} se encuentra desbloqueado',
  currentlyLocked: 'Actualmente el {entity} se encuentra bloqueado',
  weighingAvailableIs: 'La ponderación disponible es de:',
  hoursAvailableIs: 'Las horas disponibles son:',
  requiredFieldMaxHours: 'Este campo es obligatorio y no debe exceder las {max} horas pedagógicas totales.',
  cannotChangeWeighingClosedEvals: 'No puede cambiar la Ponderación dado que existen evaluaciones ya cerradas.',
  toChangeWeighingInstructions1: 'Si aún así se desea cambiar la Ponderación presione en',
  toChangeWeighingInstructions2: 'y abra las evaluaciones que se indicarán en la ventana.',
  seeMore: 'ver más',
  noCreatedEntitiesFeminine: 'No cuenta con {entity} creadas',
  goToCurricularDefinitionsToCreate: 'Diríjase a Definiciones Curriculares para poder crear {entity}.',
  noEntitiesInSelected: 'No cuenta con ningún {entity1} en las {entity2} seleccionada para esa {entity3}.',
  cannotDeleteEntityClosedEvals: 'No se puede eliminar el {entity} dado que existen Evaluaciones ya cerradas. Si aún así desea eliminar el {entity} presione el botón y abra las Evaluaciones que se indicarán en la ventana.',
  selectAnOption: '-- Seleccione una de las opciones --',
  writing: 'Redacción',
  deletePerformanceIndicator: 'Eliminar Indicador de Desempeño',
  missingFields: 'Faltan campos',
  ensureCompleteFields: 'Por favor, asegúrese de completar los campos.',
  orderRepeatedConfirm: 'El orden de la Unidad está repetido ¿desea continuar guardando?',
  orderMismatchWarning: '¡Esta acción provocará que se desajuste el orden de las Unidades!',
  cannotSaveEntities: 'No se pueden guardar los {entity}',
  entityNotYetSaved: 'Los {entity} todavía no ha sido guardada.',
  confirmUnlinkEntity: '¿Está seguro de quitar el vínculo con el {entity1} de la {entity2}?',
  unlinkWarningText: 'Al aplicar esto, el {entity1} pasa a ser independiente de la {entity2}. En caso que se modifique este último, no se vería reflejado el cambio en el {entity1}',
  specifyWeeksDescription: 'Especificar las semanas que tomará de la Unidad de Aprendizaje.',
  specifyWeighingFor: 'Especifica el porcentaje de tributación para la {entity}.',
  specifyPositionDescription: 'Puede especificar la posición o el orden.',
  requiredFieldMaxWeighing: 'Este campo es obligatorio y no debe exceder {max}%.',
  mustSelect: 'Debe seleccionar un {entity}.',
  link: 'Vincular',
  apply: 'Aplicar',
  nameFieldDescription: 'Puede Agregarle un nombre al {entity}.',
  genericPerformanceIndicator: 'Indicador de Desempeño de Competencia Genérica',
  selectEntityTooltip: 'Seleccionar un {entity1} ya creado de la {entity2}.',

  // ========== Matter Program Evaluation Draggable Component ==========
  editBibliographicResources: 'Editar Recursos Bibliográficos',
  editActivityEvaluation: 'Editar Actividad/Evaluación',
  deleteActivityEvaluation: 'Eliminar Actividad/Evaluación',
  confirmDeleteEntity: '¿Está seguro de que desea eliminar {entity}?',
  hrs: 'Hrs',
  the: 'la',
  theEvaluation: 'la evaluación',

  // ========== M Evaluation Bibliographic Resource Component ==========
  bibliographicResource: 'Recurso Bibliográfico',
  createBibliographicResource: 'Crear Recurso Bibliográfico',
  mandatoryBibliography: 'Bibliografía Obligatoria',
  complementaryBibliography: 'Bibliografía Complementaria',
  bibliographicResourceDeleted: 'Recurso Bibliográfico eliminado.',
  bibliographicResourceCreated: 'Recurso Bibliográfico creado.',
  bibliographicResourceUpdated: 'Recurso Bibliográfico actualizado.',
  fieldMinLength: 'Este campo debe tener al menos {min} caracteres.',

  // ========== Matter Program Evaluation Form Component ==========
  descriptionForStudent: 'Descripción para el Estudiante',
  activityOrEvaluation: 'Actividad o Evaluación',
  evaluativeAgent: 'Agente Evaluativo',
  workType: 'Tipo de Trabajo',
  examiner: 'Examinador',
  numberOfStudents: 'N° Estudiantes',
  autonomousWorkActivityStudent: 'Actividad de Trabajo Autónomo del/la Estudiante',
  supportResources: 'Recursos de Apoyo',
  mustBeGreaterThanZeroAnd: 'Debe ser Mayor que 0 y',
  mustNotExceed: 'No debe exceder',
  thisFieldIsRequired: 'Este campo es requerido.',
  createSupportResource: 'Crear Recurso Apoyo',
  createdFeminine: 'creadas',
  editDescriptionForStudent: 'Editar Descripción para el Estudiante',
  editDescriptionOf: 'Editar Descripción de la {entity}',
  selectOneOrMoreEvaluativeAgents: 'Seleccione uno o varios Agentes Evaluativos',
  noEvaluativeAgents: 'No cuenta con Agentes Evaluativos',
  selectOneOrMoreAutonomousActivities: 'Seleccione uno o varias Actividades de Trabajo Autónomo',
  noAutonomousActivities: 'No cuenta con Actividades de Trabajo Autónomo',
  addSupportResources: 'Agregar Recursos de Apoyo',

  // ========== Test Component ==========
  actionCannotBeRevertedOnSave: '¡Esta acción no se podrá revertir al guardar!',

  // ========== Mat Eva Stu Env Tim All Input Component ==========
  hoursNotAssociatedWith: 'Son horas que no están asociadas a {gender} {entity} seleccionados.',
  surplus: 'Excedente',
  deleteHour: 'Eliminar Hora',

  // ========== Learning Experience Component ==========
  deleteLearningExperienceConfirm: '¿Está seguro de que desea eliminar la {entity}?',
  evaluations: 'Evaluaciones',

  // ========== Assistant Profile Component ==========
  assistantProfileFor: 'Perfil ayudante para la {entity}',
  assistantProfile: 'Perfil ayudante',
  assistantRole: 'Rol del ayudante',
  addNewAssistantProfile: 'Agregar un nuevo perfil del ayudante',
  deleteAssistantProfile: 'Eliminar el perfil del ayudante',
  editAssistantProfile: 'Editar perfil ayudante',
  editAssistantRole: 'Editar rol del ayudante',
  assistantProfileCreated: 'Perfil del asistente creado.',
  assistantProfileUpdated: 'Perfil del ayudante actualizado.',
  deleteAssistantProfileConfirm: '¿Está seguro de que desea eliminar el perfil del ayudante?',
  assistantProfileDeleted: 'Se eliminó el perfil del ayudante.',

  // ========== Teaching Profile Component ==========
  teachingProfile: 'Perfil docente',
  addNewTeachingProfile: 'Agregar un nuevo perfil docente',
  editTeachingProfile: 'Editar perfil docente',
  deleteTeachingProfile: 'Eliminar el perfil docente',
  createTeachingProfile: 'Crear perfil docente',
  theoryHours: 'Horas teóricas',
  practicalHours: 'Horas prácticas',
  nonAttendanceHours: 'Horas no presenciales',
  professionalExperienceYears: 'Años de experiencia profesional',
  professionalExperienceYearsTooltip: 'Años de experiencia laboral en el área.',
  teachingProfileCreated: 'Perfil docente creado.',
  teachingProfileUpdated: 'Perfil docente actualizado.',
  deleteTeachingProfileConfirm: '¿Está seguro de que desea eliminar el perfil docente?',
  teachingProfileDeleted: 'Se eliminó el perfil docente.',

  // ========== Bibliographic Resources Component ==========
  canAddUpTo: 'Puede añadir hasta {max} Recursos Bibliográficos',
  addResourcesSeparately: 'Agregue los Recursos por separado',
  editBibliographicResource: 'Editar Recurso Bibliográfico',
  exceededMaxBibliographicResources: 'Supero el máximo de Recursos Bibliográficos',
  deleteBibliographicResourceConfirm: '¿Está seguro de que desea eliminar la Bibliografía {type}?',

  // ========== Resources Learning Environment Component ==========
  resourcesByLearningEnvironment: 'Recursos por ambiente de aprendizaje (Referencia Ficha FER)',
  editResourcesByLearningEnvironment: 'Editar recursos por ambiente de aprendizaje (Referencia Ficha FER)',
  resourcesByLearningEnvironmentUpdated: 'Recursos por ambiente de aprendizaje (Referencia Ficha FER) actualizado.',

  // ========== Teaching Support Resources Component ==========
  teachingSupportResources: 'Recursos de apoyo a la docencia',
  createResource: 'Crear recurso',
  editTeachingSupportResource: 'Editar recurso de apoyo a la docencia',
  deleteInstanceConfirm: '¿Está seguro de que desea eliminar esta instancia de "{type}"?',
  teachingSupportResourceDeleted: 'Se eliminó el recurso apoyo a la docencia.',
  teachingSupportResourceUpdated: 'Se actualizó el recurso apoyo a la docencia.',
}
